import React, { useEffect, useState } from 'react'
import useTrans from '@hooks/useTrans'
import { cn } from '@utils/safeTs'
import { PosizioneType } from '@utils/types'
import { Button, FormField, FormSelect, Modal } from '@components/atoms'
import styles from './EditorAddPosizioneModal.module.sass'


interface Props {
  posizioni?: PosizioneType[]
  open?: boolean
  onClose?: () => void
  onApply?: (posizioneId: number) => void
  className?: string
}

const EditorAddPosizioneModal = (props: Props) => {

  const { 
    posizioni = [],
    open = false,
    onClose,
    onApply,
    className = '',
  } = props

  const t = useTrans()
  const [localValue, setLocalValue] = useState(undefined)

  useEffect(() => {
    if (!open)
      setLocalValue(undefined)
  }, [open])

  return (
    <Modal 
      id={'editoraddposizionemodal'}
      open={open}
      onClose={onClose}
      title={t("Aggiungi posizione")}      
      description={t("Seleziona la posizione da aggiungere all'editor")}
      buttons={(
        <>
          <Button variant="secondary" size="large" label={t("Annulla")} onClick={onClose} />
          <Button 
            variant='primary' 
            size="large" 
            label={t("Applica modifica")} 
            onClick={onApply ? () => onApply(parseInt(localValue)) : undefined} 
            disabled={!localValue} 
          />
        </>
      )}
      className={cn(styles.root, className)}
      mainClassName={styles.main}
      headerClassName={styles.head}
      bodyClassName={styles.body}
    >
      <div className={styles.selection}>
        <FormField 
          id={'editoraddposizionemodal_posizione'}
          label={t("Posizione")}
        >
          <FormSelect 
            id={'editoraddposizionemodal_posizione'}
            value={localValue}
            placeholder={t("Seleziona posizione")}
            onChange={(e) => setLocalValue(e.target.value)}
            options={posizioni.map(t => ({
              label: t.nome, 
              value: t.id?.toString()
            }))}
          />
        </FormField>
      </div>
    </Modal>
  )
}

export default EditorAddPosizioneModal
